import { useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi } from "@/lib/useApi";
import { useAuth } from "@/context/AuthContext";
import { Field } from "./Field";

export default function PicSelect({ value, onChange, testid = "pic-select" }) {
  const { user } = useAuth();
  const { data } = useApi("/users/pic");
  useEffect(() => {
    if (!value && user?.id) onChange(user.id);
  }, [value, user, onChange]);
  return (
    <Field label="Penanggung Jawab (PIC)" required>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger className="h-12" data-testid={testid}>
          <SelectValue placeholder="Pilih PIC" />
        </SelectTrigger>
        <SelectContent>
          {(data || []).map((u) => (
            <SelectItem key={u.id} value={u.id} data-testid={`pic-option-${u.id}`}>
              {u.name} <span className="text-zinc-400">· {u.role}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}
